module.exports = __webpack_public_path__ + "img/1.8be7f6ef.png";